angular
  .module("app")
  .controller("SignedContractsCtrl", function (
    $scope,
    $rootScope,
    FactoryObj,
    $digitalSignatureService,
    HttpService,
    $configService,
    $userService,
    $simulationService,
    $transactionFactory,
    $location,
    $workflowService,
    FinancialModel,
    $download

  ) {

    $scope.pdfUrl = "";
    $scope.pdfPrefix = $configService.getAppConfig().envData.digitalSignPdfPrefix;

    $scope.selectedContract = FactoryObj.selectedContract;
    $scope.loading_b = false;
    $scope.contractSelectionIndex = 0;
    $scope.stepIndex = 0;
    $scope.contract = {
      idContract: FactoryObj.selectedContract.idContract,
      pin: null,
      otp: null
    };
    $scope.tipoFirmatario = FactoryObj.selectedContract.tipoFirmatario;
    console.log("tipoFirmatario=" + $scope.tipoFirmatario);

    $scope.errPin = false;
    $scope.errPP = false;

    //      First step
    //		$scope.viewIndex = 0;
    //		$scope.viewIndex = 3;

    $scope.start = function () {

    };

    $scope.getTemplateUrl = function () {
      return context + "route/signedContracts/pdf-viewer.html"
    };

    $scope.initAcknowledgmentCheckboxes = function () {
      $scope.start();
      $scope.mycheck = [
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false]
      ];

      //			$scope.acknowledgmentCheckboxes = $scope.documents.map(function(el){
      //					el.selected = false;
      //					return el;
      //				});
      //			console.log("ACKNOWLEGEMENT="+$scope.acknowledgmentCheckboxes);
    };

    $scope.initAcknowledgmentCheckboxes();

    $scope.checkAcknowledgment = function (stepIndex) {
      $scope.acknowledgmentCheckboxes[stepIndex].selected = !$scope
        .acknowledgmentCheckboxes[stepIndex].selected;
    };

    $scope.areChecked = function (stepIndex, Index) {
      console.log("mycheck " + stepIndex + " = " + $scope.mycheck[stepIndex]);
    };

    $scope.initialize = function () {
      $scope.start();
      console.log(
        "rootScope.appConfig.user.parent.tel=",
        $configService.getUser().tel
      );
      if ($scope.tipoFirmatario == "PROSPECT") {
        $scope.viewIndex = 0;
        $scope.mobileCertification();
      } else {
        $scope.loading_b = true;
        $scope.startContractSignature(FactoryObj.selectedContract);
      }

      //$scope.verifyMobileCertification();
      $scope.getTemplateUrl();
      $scope.getDealerUser();
    };

    $scope.mobileCertification = function () {
      console.log("INVOKING soapCertificaNumeroTelefono");
      HttpService.send("/simulator/contract/soapCertificaNumeroTelefono", {
        numeroTelefono: $configService.getUser().tel,
        idContract: FactoryObj.selectedContract.idContract
      }).then(function (response) {
        /////////////WARNING - DA ELIMINARE!!!!!!!!
        //HttpService.send('/simulator/contract/soapCertificaNumeroTelefono', {numeroTelefono: 3487351474, idContract: FactoryObj.selectedContract.appContract.idContract }, false).then(function(response){
        console.log("mobileCertification SENT");
        if (response.success == false) {
          $scope.loading_b = false;
          console.log("ERROR in soapCertificaNumeroTelefono");
          $rootScope.$broadcast("addAlert", {
            text: "ERROR_SENDING_OTP"
          });
        } else {
          console.log("SUCCESS  soapCertificaNumeroTelefono");
          $scope.otpTransactionId =
            response.startMobileNumberCertification.context.transactionId;
          console.log("otpTransactionId" + $scope.otpTransactionId);
          $rootScope.$broadcast("addAlert", {
            text: "OTP_SENT"
          });
        }
      });
    };

    $scope.checkMe = function (pin1) {
      console.log("pin1.$viewValue=" + pin1.$viewValue);
    };

    $scope.mobileSendOtp = function () {
      console.log("INVOKING soapCertificaNumeroTelefono");
      HttpService.send("/simulator/contract/sendOtp", {
        taskId: $scope.taskId,
        sessionKey: $scope.sessionKey,
        idContract: FactoryObj.selectedContract.idContract
      }).then(function (response) {
        console.log("SendOtp SENT");
        if (response.success == false) {
          $scope.loading_b = false;
          console.log("ERROR in SendOtp");
          $rootScope.$broadcast("addAlert", {
            text: "ERROR_SENDING_OTP"
          });
        } else {
          console.log("SUCCESS  SendOtp");
          $rootScope.$broadcast("addAlert", {
            text: "OTP_SENT"
          });
        }
      });
    };

    $scope.checkOtp = function (otp) {
      $scope.loading_b = true;
      HttpService.send("/simulator/contract/soapVerificaCertificatoNumTel", {
        otpTransactionId: $scope.otpTransactionId,
        otp: otp,
        idContract: FactoryObj.selectedContract.idContract
      }).then(function (response) {
        console.log("soapVerificaCertificatoNumTel", response);
        if (response.success == false) {
          console.log("ERROR in soapVerificaCertificatoNumTel");
          $scope.loading_b = false;
        } else {
          console.log("SUCCESS  soapVerificaCertificatoNumTel");
          $scope.startContractSignature(FactoryObj.selectedContract);
        }
      });
    };

    $scope.getToken = function () {
      $digitalSignatureService
        .getNewTokenInfocert($scope.selectedContract.idContract, $scope.selectedContract.dossierId)
        .then(function (response) {
          console.log("getNewTokenInfocert", response);
          if (response.success == false) {
            console.log("ERROR in getNewTokenInfocert");
            $scope.loading_b = false;
          } else {
            console.log("SUCCESS  getNewTokenInfocert");
          }
        });
    };

    $scope.goToPreviousStep = function () {
      $scope.stepIndex--;
      $scope.pdfUrl = $scope.pdfPrefix + $scope.documents[$scope.stepIndex].url;
    };

    $scope.goToNextStep = function () {
      if ($scope.stepIndex < $scope.documents.length) {
        $scope.stepIndex++;
        if ($scope.stepIndex == $scope.documents.length) {
          $scope.prepSignature();
        } else {
          // change pdf url
          console.log(
            "goToNextStep - STEPINDEX=" +
            $scope.stepIndex +
            " PDFURL" +
            $scope.documents[$scope.stepIndex].url
          );
          $scope.pdfUrl =
            $scope.pdfPrefix + $scope.documents[$scope.stepIndex].url;
          // reset pdf scrollbar position
          $(".mCustomScrollbar").mCustomScrollbar("scrollTo", "top", {
            moveDragger: true,
            scrollInertia: 0,
            timeout: 0
          });
          // check if the user has scrolled to the bottom of the div
          //$scope.checkScroll();
        }
      }
    };

    function Document(id, clauses) {
      var self = this;

      function Clause(id, value) {
        var self = this;
        self.id = id;
        self.value = value;
      }
      self.id = id;
      self.clauses = [];
      clauses.forEach(function (clause) {
        self.clauses.push(new Clause(clause.id, true));
      });
    }

    function Clauses(id, clauses) {
      var self = this;

      function Clause(id, value) {
        var self = this;
        self.id = id;
        self.value = value;
      }
      self.id = id;
      self.clauses = [];
      clauses.forEach(function (clause) {
        self.clauses.push(new Clause(clause.id, true));
      });
    }

    $scope.prepSignature = function () {
      $digitalSignatureService
        .enrollmentPreparesignature({
          taskId: $scope.taskId,
          sessionKey: $scope.sessionKey,
          idContract: FactoryObj.selectedContract.idContract
        })
        .then(function (response) {
          if (response.success) {
            console.log("enrollmentPreparesignature  OK");
          } else {
            console.log("enrollmentPreparesignature  KO");
          }
        });
    };

    $scope.signContracts = function () {
      console.log("SIGN CONTRACTS");
      $scope.loading_b = true;
      var input = {
        arrayDocument: "",
        otp: $scope.contract.otp,
        pin: $scope.contract.pin,
        taskId: $scope.taskId,
        sessionKey: $scope.sessionKey,
        idContract: FactoryObj.selectedContract.idContract
      };
      var arrayDocuments = [];
      $scope.documents.forEach(function (doc) {
        arrayDocuments.push(new Document(doc.id, doc.signatures));
      });

      //parseObject
      var b = arrayDocuments;
      var a = JSON.stringify(eval(b));
      input.arrayDocument = '"documents":' + a;
      //end

      $digitalSignatureService
        .enrollmentSigncontracts(input)
        .then(function (response) {
          $scope.loading_b = false;
          if (response.success) {
            $scope.updateContractSigned();
          }
        });
    };

    $scope.updateContractSigned = function () {
      console.log("UPDATE CONTRACT");
      $scope.loading_b = true;

      $digitalSignatureService
        .updateContract($scope.selectedContract.idContract, $scope.selectedContract.dossierId)
        .then(function (response) {
          $scope.loading_b = false;
          if (response.success) {
            $rootScope.$broadcast("addAlert", {
              text: "CONTRACT_SIGNED"
            });
            callGetInfoPostSignature();

          }
        });
    };

    $scope.addItemEnabled = function () {
      return (
        $scope.clausolePrecontrattuali &&
        $scope.clausolePrecontrattuali.every(function (value) {
          return value.optional == true;
        })
      );
    };

    $scope.checkedClause = function (index) {
      $scope.clausolePrecontrattuali[1].optional = true;
      $scope.clausolePrecontrattuali[index].optional = !$scope
        .clausolePrecontrattuali[index].optional;
      console.log($scope.clausolePrecontrattuali[index]);
    };

    /*
    $scope.checkScroll = function(){
      $timeout(function(){
        $('#document-wrapper-'+$scope.stepIndex).mCustomScrollbar({
          theme: "dark",
          scrollbarPosition: "outside",
          callbacks:{
            onInit:function(){
            $(this).data("mCS").opt.callbacks.onTotalScrollOffset=Math.abs(this.mcs.content.innerHeight()-($('#document-wrapper-'+$scope.stepIndex).position().top+$('#document-wrapper-'+$scope.stepIndex).outerHeight(true)));
            },
            onTotalScroll:function(){
            var scrollbarHeight = parseInt($('#document-wrapper-'+$scope.stepIndex).css('padding-top').slice(0,-2))*2 + $('#document-wrapper-'+$scope.stepIndex).height();
            var dragger = $('#document-wrapper-'+$scope.stepIndex+' .mCSB_dragger');
            var draggerHeight = dragger.height();
            var currentDraggerPosition = parseInt(dragger.css('top').slice(0,-2));
            if(currentDraggerPosition+draggerHeight == scrollbarHeight){
              $('#checkbox-wrapper-'+stepIndex).removeClass('disabled-item');
            }
            },
            alwaysTriggerOffsets:false
          }
        });
      },300);
    }*/

    $scope.canConfirmContract = function () {
      return (
        $scope.digitalSignatureForm.$invalid ||
        $scope.digitalSignatureForm.$error.required ||
        $scope.digitalSignatureForm.$error.equal
      );
    };

    $scope.startContractSignature = function (contract) {
      if (FactoryObj.appCertificate == null) {
        //da cambiare in corso d'opera! - appCertificate e' sempre null per il momento
        $digitalSignatureService
          .getNewTokenInfocert($scope.selectedContract.idContract, $scope.selectedContract.dossierId)
          .then(function (response) {
            if (response.success) {
              $scope.token = response.newTokenInfocert;
              console.log("TOKEN=" + $scope.token);
              $digitalSignatureService
                .digitalSignatureStart({
                  token: $scope.token,
                  idContract: FactoryObj.selectedContract.idContract
                })
                .then(function (response) {
                  if (response.responseRestInfocert) {
                    $scope.taskId = response.responseRestInfocert.taskId;
                    console.log("FOUND TASKID=" + $scope.taskId);
                    $scope.sessionKey =
                      response.responseRestInfocert.sessionKey;
                    console.log("FOUND SESSIONKEY=" + $scope.sessionKey);
                    $digitalSignatureService
                      .processInformations({
                        token: $scope.token,
                        sessionKey: $scope.sessionKey,
                        idContract: FactoryObj.selectedContract.idContract
                      })
                      .then(function (response) {
                        if (response) {
                          $scope.startEnrollment();
                        }
                      });
                  } else {
                    $scope.loading_b = false;
                    console.log("digitalSignatureStart ERR");
                  }
                });
            } else {
              $scope.loading_b = false;
              console.log("getNewTokenInfocert ERR");
            }
          });
      } else {
        // nuovo certificato
        $scope.viewIndex = 0;
      }
    };

    $scope.startEnrollment = function () {
      $scope.loading_b = true;
      $digitalSignatureService
        .enrollmentStart({
          taskId: $scope.taskId,
          sessionKey: $scope.sessionKey,
          idContract: FactoryObj.selectedContract.idContract
        })
        .then(function (response) {
          if (response) {
            $scope.loading_b = false;
            if (response.success) {
              if (
                response.responseRestInfocert.status ==
                "RUNNING_PENDING_EMISSIONE"
              ) {
                $scope.mobileSendOtp();
                $scope.viewIndex = 2;
              } else if (
                response.responseRestInfocert.status ==
                "RUNNING_PENDING_FIRMA" ||
                $scope.tipoFirmatario == "ACTUAL"
              ) {
                ////// check !!!!!
                $scope.documents = response.responseRestInfocert.documents;
                $scope.pdfUrl = $scope.pdfPrefix + $scope.documents[0].url;
                var index;
                for (var i = 0; i < $scope.documents.length; i++) {
                  index = $scope.documents[i].name.lastIndexOf("_");
                  if (index != -1) {
                    $scope.documents[i].name = $scope.documents[
                      i
                    ].name.substring(0, index);
                  }
                }
                console.log("PDFTAB PIN BEFORE=" + $scope.contract.pin);
                //							$scope.contract.pin="";
                $scope.viewIndex = 3;
              } else if ($scope.tipoFirmatario == "PROSPECT") {
                $scope.clausolePrecontrattuali =
                  response.responseRestInfocert.clauses;
                console.log(
                  "JSON.parse clausolePrecontrattuali TEXT=" +
                  $scope.clausolePrecontrattuali[0].text
                );
                $scope.viewIndex = 1;
              }
            }
          }
        });
    };

    $scope.codiciTab = function () {
      $scope.loading_b = true;

      var strClauses = '{"clauses":[';
      for (var i = 0; i < $scope.clausolePrecontrattuali.length; i++) {
        strClauses +=
          '{"id":"' +
          $scope.clausolePrecontrattuali[i].id +
          '","value":"true"}';
        if (i < $scope.clausolePrecontrattuali.length - 1) strClauses += ",";
      }
      strClauses += "]};";
      console.log("CLAUSES STRING=" + strClauses);

      $digitalSignatureService
        .enrollmentAcceptconditions({
          taskId: $scope.taskId,
          sessionKey: $scope.sessionKey,
          clauses: strClauses,
          idContract: FactoryObj.selectedContract.idContract
        })
        .then(function (response) {
          if (response) {
            console.log("enrollmentAcceptconditions OK");
            $scope.loading_b = false;
            $scope.viewIndex = 2;
          }
        });
    };

    $scope.pdfTab = function (pin, pin2, phrase, phrase2, otp) {
      $scope.loading_b = true;
      console.log("PDFTAB PIN=" + pin);
      console.log("PDFTAB PIN2=" + pin2);
      console.log("PDFTAB PHRASE=" + phrase);
      console.log("PDFTAB PHRASE2=" + phrase2);
      console.log("PDFTAB OTP=" + otp);

      $digitalSignatureService
        .enrollmentCreatecertificate({
          taskId: $scope.taskId,
          sessionKey: $scope.sessionKey,
          otp: otp,
          passphrase: phrase,
          passphraseConfirmation: phrase2,
          pin: pin,
          pinConfirmation: pin2,
          idContract: FactoryObj.selectedContract.idContract
        })
        .then(function (response) {
          if (response) {
            $scope.loading_b = false;
            if (response.success) {
              console.log("enrollmentCreatecertificate  OK");
              $scope.documents = response.responseRestInfocert.documents;
              $scope.pdfUrl = $scope.pdfPrefix + $scope.documents[0].url;
              var index;
              for (var i = 0; i < $scope.documents.length; i++) {
                index = $scope.documents[i].name.lastIndexOf("_");
                if (index != -1) {
                  $scope.documents[i].name = $scope.documents[
                    i
                  ].name.substring(0, index);
                }
              }
              console.log("PDFTAB PIN BEFORE=" + $scope.contract.pin);
              $scope.contract.pin = "";
              $scope.viewIndex = 3;
            } else {
              //						$rootScope.$broadcast('addAlert', { text: "OTP_NOT_VALID" });
            }
          }
        });
    };

    $scope.testRest = function (token) {
      var inputRest = {
        token: token
      };
      HttpService.send(
        "/simulator/contract/processInformations",
        inputRest
      ).then(function (response) {
        if (response) {
          console.log("rest" + response);
        }
      });
    };

    $scope.generateDownloadLink = function (nameFile) {
      var url =
        "/uni/download/service-infos/" +
        encodeURIComponent(nameFile) +
        "/"

      $download.getGenericDownload(url)
        .then(function (response) {
          console.log(response);
        })

    };


    $scope.getDealerUser = function () {
      $userService.getDealerUser()
        .then(function (dealer) {
          if (dealer) {
            $scope.dealerUser = dealer;
          }
        });
    }

    var callGetInfoPostSignature = function () {

      $simulationService.getInfoPostSignature($scope.selectedContract.dossierId)
        .then(function (response) {
          if (response.success) {
            $scope.infoPostSignature = response;
            $scope.viewIndex = 99;
          }

        })
    }

    $scope.goToDigital = function (idWf) {
      $scope.loaderRiprendi = true;
      $workflowService
        .resumeInstance(idWf, "WF_DIGITAL")
        .then(function (response) {
          $scope.loaderRiprendi = false;
          response.idWfInstance = idWf;
          var financialModel = FinancialModel.build(response);
          Object.assign(financialModel, {
            frontEndOptions: response.frontEndOptions,
          });
          $transactionFactory.set(financialModel);
          $location.path("/digitalLeasing");
        })
        .catch(function () {
          $scope.loaderRiprendi = false;
        })

    }

    $scope.pinsAreNotEqual = function (inputName, inputName2) {
      if ((inputName.$viewValue != inputName2.$viewValue) && inputName2.$viewValue) {
        $scope.errPin = true;
      } else {
        $scope.errPin = false;
      }
    };

    $scope.passAreNotEqual = function (inputName, inputName2) {
      if ((inputName.$viewValue != inputName2.$viewValue) && inputName2.$viewValue) {
        $scope.errPP = true;
      } else {
        $scope.errPP = false;
      }
    };

  });

app.filter("capitalize", function () {
  return function (input) {
    return !!input ?
      input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() :
      "";
  };
});